import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function Overlay({ open, onClose, image, imageAlt, label, children }) {
  useEffect(() => {
    if (open) {
      window.__lenis?.stop();
      document.body.style.overflow = "hidden";
    } else {
      window.__lenis?.start();
      document.body.style.overflow = "";
    }
    return () => {
      window.__lenis?.start();
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="destination-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[60] flex items-center justify-center bg-forest/80 p-3 backdrop-blur-sm md:p-8"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, y: 48, scale: 0.985 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 32, scale: 0.99 }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
            className="thin-scroll relative max-h-[92vh] w-full max-w-5xl overflow-y-auto bg-ivory"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="overlay-close-button"
              onClick={onClose}
              aria-label="Close"
              className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center bg-ivory/90 text-forest transition-colors hover:bg-forest hover:text-ivory"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="relative h-64 md:h-auto md:min-h-[540px]">
                <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" />
                {label && (
                  <span className="absolute bottom-4 left-4 bg-forest/80 px-4 py-2 text-[10px] uppercase tracking-widest2 text-gold">
                    {label}
                  </span>
                )}
              </div>
              <div className="p-7 md:p-12">{children}</div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
